import React from 'react';
import { Tooltip } from '@mui/material';
import RHFCheckbox from '#component/form/rhf/rhf-checkbox';
import {
  ChannelLabel,
  ChannelsRow,
  InfoBadge,
  StyledInfoIcon
} from './styles';

export const notificationChannels = [
  {
    name: 'emailMsg',
    label: 'Email',
    tooltip: 'Receive alert notifications at your email address.'
  },
  {
    name: 'siteMsg',
    label: 'Push',
    tooltip: 'Receive browser push notifications.'
  },
  {
    name: 'notificationMsg',
    label: 'Site',
    tooltip: 'Show notifications in the web portal notification center.'
  },
  {
    name: 'smsMsg',
    label: 'SMS',
    tooltip: 'Receive alert notifications by SMS. This channel is not available yet.',
    disabled: true
  }
];

const NotificationChannels = () => (
  <ChannelsRow>
    {notificationChannels.map(({ name, label, tooltip, disabled }) => (
      <RHFCheckbox
        key={name}
        name={name}
        disabled={disabled}
        label={(
          <ChannelLabel>
            {label}
            <Tooltip title={tooltip} placement="top" arrow>
              <InfoBadge
                aria-label={`${label} notification info`}
                onClick={event => {
                  event.preventDefault();
                  event.stopPropagation();
                }}
              >
                <StyledInfoIcon />
              </InfoBadge>
            </Tooltip>
          </ChannelLabel>
        )}
      />
    ))}
  </ChannelsRow>
);

export default NotificationChannels;
